"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const pile_png_1 = __importDefault(require("../../assets/img/pile.png"));
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-5195aa89"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "maxContent" };
const _hoisted_2 = { class: "left" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "item" };
const _hoisted_5 = { class: "label" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { style: {
        color: '#333333'
    } };
const _hoisted_8 = { class: "value" };
const _hoisted_9 = {
    key: 1,
    class: "productionImg"
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("img", {
    src: pile_png_1.default,
    alt: ""
}, null, -1));
const _hoisted_11 = { style: {
        color: '#333333'
    } };
const _hoisted_12 = { class: "right" };
const _hoisted_13 = { class: "icon" };
const _hoisted_14 = ["src"];
const _hoisted_15 = { class: "info" };
const _hoisted_16 = { class: "title" };
const _hoisted_17 = { class: "content" };
const processList_1 = __importDefault(require("./processList"));
const nullText_1 = require("./nullText");
const vue_3 = require("vue");
const ant_design_vue_1 = require("ant-design-vue");
const vue_router_1 = require("vue-router");
const index_1 = require("../../service/index");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        const router = (0, vue_router_1.useRouter)();
        const productionInfo = (0, vue_3.ref)();
        const process = (0, vue_3.ref)(processList_1.default);
        const pileName = (0, vue_3.ref)('');
        const SN = (0, vue_3.ref)('');
        const stakeQRCode = (0, vue_3.ref)('');
        const fromDevice = (0, vue_3.ref)(false);
        const shippingStatus = (0, vue_3.ref)(''); //该产品的发货状态
        const searchCode = (params) => {
            getProdInfo(params.SN, params.stakeQRCode);
        };
        const toMes = () => {
            if (!SN.value) {
                ant_design_vue_1.message.info('查询SN为空，请核实后重试');
                return;
            }
            window.open(`https://mes-cloud-web.wbstar.com/?initKey=ProduceInformation&sn=` + SN.value, '_blank');
        };
        const getProdInfo = (sn, stakeQR) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            SN.value = sn;
            stakeQRCode.value = stakeQR;
            const res = yield (0, index_1.searchAllNodeInfo)(sn, 'ALL');
            (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.splice(1, 0, {
                label: 'img',
                name: '',
                orderIndex: 0,
                value: '',
            });
            const res2 = yield (0, index_1.manufactureList)({ sn });
            const productionObj = res2 === null || res2 === void 0 ? void 0 : res2.data[0];
            let list = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.map((item, index) => {
                let linkLabel = '';
                let linkUrl = '';
                let data = undefined;
                switch (item.label) {
                    case '一级物料名称':
                        pileName.value = item.value;
                        break;
                    case '生产工单号':
                        linkLabel = '查看同批次';
                        linkUrl = '/productionInfoList';
                        data = 'shengchangongdanhao';
                        break;
                    case '销售订单号':
                        linkLabel = '查看同批次';
                        linkUrl = '/productionInfoList';
                        data = 'xiaoshoudingdanhao';
                        break;
                    // case '制令单号':
                    //     linkLabel = '查看同批次'
                    //     linkUrl = '/productionInfoList'
                    //     data = ''
                    //     break
                    case '交货单号':
                        linkLabel = '查看同批次';
                        linkUrl = '/productionInfoList';
                        data = 'jiaohuodanhao';
                        break;
                    case '充电枪SN':
                        linkLabel = '更多溯源器件';
                        linkUrl = '/deviceInfo';
                        data = 'chengpinsnma';
                        break;
                }
                let value = "--";
                if (item.value !== null && item.value !== "") {
                    value = item.value;
                }
                else {
                    for (let i = 0; i < nullText_1.prodInfoNullTextList.length; i++) {
                        if (nullText_1.prodInfoNullTextList[i].label === item.label) {
                            if (nullText_1.prodInfoNullTextList[i].judgement === '') {
                                value = nullText_1.prodInfoNullTextList[i].value;
                                break;
                            }
                            if (nullText_1.prodInfoNullTextList[i].judgement === 'shippingStatus') {
                                if (shippingStatus.value === '未发货') {
                                    value = nullText_1.prodInfoNullTextList[i].value(true);
                                }
                                else {
                                    value = nullText_1.prodInfoNullTextList[i].value(false);
                                }
                            }
                        }
                    }
                }
                return {
                    name: item.label,
                    value,
                    key: item.name,
                    data,
                    linkLabel,
                    linkUrl,
                    offset: [4, 6, 8, 10].includes(index)
                };
            }).filter((item) => item.name !== '一级物料名称');
            list = [...list, {
                    name: '功能测试结果',
                    value: productionObj === null || productionObj === void 0 ? void 0 : productionObj.gongnengceshijieguo,
                    key: 'gongnengceshijieguo',
                    offset: false
                }, {
                    name: '老化测试结果',
                    value: productionObj === null || productionObj === void 0 ? void 0 : productionObj.laohuaceshijieguo,
                    key: 'laohuaceshijieguo',
                    offset: false
                }, {
                    name: '包装上线时间',
                    value: productionObj === null || productionObj === void 0 ? void 0 : productionObj.baozhuangshangxianshijian,
                    key: 'baozhuangshangxianshijian',
                    offset: false
                }];
            productionInfo.value = list;
        });
        const toNodeView = () => {
            router.push({
                path: '/nodeView',
                query: {
                    SN: SN.value,
                    stakeQRCode: stakeQRCode.value,
                }
            });
        };
        const lintTo = (item) => {
            if (item.linkUrl === '/productionInfoList') {
                router.push({
                    path: item.linkUrl,
                    state: {
                        params: {
                            [item.data]: item.value
                        }
                    }
                });
            }
            else if (item.linkUrl === '/deviceInfo') {
                router.push({
                    path: item.linkUrl,
                    query: {
                        [item.data]: SN.value,
                        suyuanqijiansn: item.value !== "数据缺失" ? encodeURI(item.value) : undefined,
                    },
                });
            }
        };
        const toMBOM = () => {
            router.push({
                path: '/MBOM',
                query: {
                    SN: SN.value,
                    stakeQRCode: stakeQRCode.value,
                }
            });
        };
        (0, vue_3.onMounted)(() => __awaiter(this, void 0, void 0, function* () {
            var _c;
            if (route.query.comeFrom === 'device') {
                fromDevice.value = true;
            }
            getProdInfo(decodeURI(route.query.chengpinsnma || ""), decodeURI(route.query.stakeQRCode || ""));
            const res = yield (0, index_1.getDomainBySN)(decodeURI(route.query.chengpinsnma || ""));
            if (((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                shippingStatus.value = res.data[0].fahuozhuangtai;
            }
        }));
        return (_ctx, _cache) => {
            const _component_HeaderNew = (0, vue_2.resolveComponent)("HeaderNew");
            const _component_ArrowLeftOutlined = (0, vue_2.resolveComponent)("ArrowLeftOutlined");
            const _component_a_button = (0, vue_2.resolveComponent)("a-button");
            const _component_SearchPile = (0, vue_2.resolveComponent)("SearchPile");
            const _component_a_tooltip = (0, vue_2.resolveComponent)("a-tooltip");
            const _component_a_col = (0, vue_2.resolveComponent)("a-col");
            const _component_a_row = (0, vue_2.resolveComponent)("a-row");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(_component_HeaderNew),
                (0, vue_2.createElementVNode)("nav", null, [
                    (0, vue_2.createVNode)(_component_a_button, {
                        class: "back",
                        onClick: _cache[0] || (_cache[0] = ($event) => ((0, vue_2.unref)(router).back()))
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_ArrowLeftOutlined),
                            (0, vue_2.createTextVNode)("返回 ")
                        ]),
                        _: 1
                    }),
                    (0, vue_2.createVNode)(_component_a_button, {
                        type: "primary",
                        class: "linkButton",
                        onClick: toNodeView
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)(" 节点视图 ")
                        ]),
                        _: 1
                    }),
                    (0, vue_2.createVNode)(_component_a_button, {
                        type: "primary",
                        class: "linkButton",
                        onClick: toMBOM
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)(" 查看BOM ")
                        ]),
                        _: 1
                    }),
                    (0, vue_2.createVNode)(_component_SearchPile, {
                        class: "searchPile",
                        onSearchCode: searchCode,
                        productionOrDevice: 0,
                        selectValue: decodeURI((0, vue_2.unref)(route).query.chengpinsnma || (0, vue_2.unref)(route).query.stakeQRCode || '')
                    }, null, 8, ["selectValue"])
                ]),
                (0, vue_2.createElementVNode)("main", null, [
                    (0, vue_2.createElementVNode)("section", _hoisted_2, [
                        (0, vue_2.createVNode)(_component_a_row, { gutter: [20, 20] }, {
                            default: (0, vue_2.withCtx)(() => [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(productionInfo.value, (item) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_a_col, {
                                        span: 8,
                                        offset: (item === null || item === void 0 ? void 0 : item.offset) === true ? 8 : 0
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            ((item === null || item === void 0 ? void 0 : item.name) !== 'img')
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(item.name), 1),
                                                            (item.linkLabel)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                                    key: 0,
                                                                    onClick: ($event) => (lintTo(item))
                                                                }, (0, vue_2.toDisplayString)(item === null || item === void 0 ? void 0 : item.linkLabel), 9, _hoisted_6))
                                                                : (0, vue_2.createCommentVNode)("", true)
                                                        ]),
                                                        (0, vue_2.createVNode)(_component_a_tooltip, { color: "#FFFFFF" }, {
                                                            title: (0, vue_2.withCtx)(() => [
                                                                (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)(item.value !== undefined && item.value !== null ?
                                                                    item.value :
                                                                    item.value === 0 ? 0 : '--'), 1)
                                                            ]),
                                                            default: (0, vue_2.withCtx)(() => [
                                                                (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)(item.value !== undefined && item.value !== null ? item.value :
                                                                    item.value === 0 ? 0 : '--'), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ])
                                                ]))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                                                    _hoisted_10,
                                                    (0, vue_2.createVNode)(_component_a_tooltip, { color: "#FFFFFF" }, {
                                                        title: (0, vue_2.withCtx)(() => [
                                                            (0, vue_2.createElementVNode)("div", _hoisted_11, (0, vue_2.toDisplayString)(pileName.value), 1)
                                                        ]),
                                                        default: (0, vue_2.withCtx)(() => [
                                                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(pileName.value), 1)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]))
                                        ]),
                                        _: 2
                                    }, 1032, ["offset"]));
                                }), 256))
                            ]),
                            _: 1
                        })
                    ]),
                    (0, vue_2.createElementVNode)("section", _hoisted_12, [
                        (0, vue_2.createVNode)(_component_a_row, { gutter: [16, 24] }, {
                            default: (0, vue_2.withCtx)(() => [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(process.value, (item) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_a_col, { span: 12 }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: "card",
                                                onClick: toMes
                                            }, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                                    (0, vue_2.createElementVNode)("img", {
                                                        src: item.url,
                                                        alt: ""
                                                    }, null, 8, _hoisted_14)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_16, (0, vue_2.toDisplayString)(item.label), 1),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_17, (0, vue_2.toDisplayString)(item.discribe), 1)
                                                ])
                                            ])
                                        ]),
                                        _: 2
                                    }, 1024));
                                }), 256))
                            ]),
                            _: 1
                        })
                    ])
                ])
            ]));
        };
    }
});
